import { useTokenRefreshTracker } from "../../utils/utils";

const UserSessionHandler = () => {
  useTokenRefreshTracker();
  return null;
};

export default UserSessionHandler;
